import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    MessageScrollerViewportDynamicStyleType
} from "./type";
import type {
    Mutable
} from "../../../../types";
import {
    getFocusRingStyle
} from "../../../../helpers/theme/state";
import {
    webStyle
} from "../../../../utils";

const stylesheet = StyleSheet.create({
    container: {
        flexShrink: 1,
        minHeight: 0,
        flexGrow: 1,
        ...webStyle({
            overscrollBehaviorY: "contain",
            outlineStyle: "solid",
            outlineWidth: 0
        })
    },
    content: {
        flexDirection: "column",
        flexGrow: 1
    }
});

export const useStyles = ({
    isScrollbarVisible,
    isFocusVisible,
    borders,
    colors
}: MessageScrollerViewportDynamicStyleType) => {
    const styles = {
        container: {
            ...getFocusRingStyle({
                isFocusVisible,
                isInset: true,
                borders,
                colors
            }),
            ...webStyle({
                scrollbarColor: isScrollbarVisible ? "auto" : "transparent transparent"
            })
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
